import type { ToneOverlay } from "../index.js";

// Voz "abuela" en castellano: cariño, preocupación, comida y mucho abrigo. Como la "dark",
// es una voz para aligerar el ánimo, así que sus líneas rotan cada dos horas
// (TONE_ROTATE_MS). Cada variante conserva los {marcadores} de la base.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} cerca, cariño — atento ahora mismo",
    "{hazard} aquí al lado, mi vida. Ojo.",
    "{hazard} cerca — no me gusta nada. Cuidado.",
    "{hazard} cerca. Ten cuidado, ¿me oyes?",
    "{hazard} aquí cerca. No te separes, ¿eh?",
  ],
  "alert.toast.escalation": [
    "El {hazard} va a peor, no esperes, hazme caso",
    "El {hazard} crece, cariño — muévete ya",
    "{hazard} peor ahora. No seas cabezota, vete.",
    "{hazard} se extiende. Ay, Señor. Date prisa.",
  ],
  "alert.toast.inPath": [
    "El {hazard} viene hacia ti — muévete, mi vida",
    "{hazard} va hacia ti, cariño — ve, ve",
    "{hazard} viene a por ti. Arriba, ¡muévete!",
    "{hazard} casi en tu puerta — sal ya, por favor",
  ],
  "alert.toast.allClear": [
    "Todo tranquilo cerca de {place}, gracias a Dios",
    "{place} está en calma. Siéntate, respira.",
    "A salvo cerca de {place}, cariño. Qué susto.",
    "Todo bien cerca de {place}. Ahora bebe agua.",
  ],
  "alert.toast.tap": [
    "Ven, toca aquí — yo te digo qué hacer",
    "Toca, cariño — yo te guío",
    "Toca aquí. La abuela tiene un plan.",
  ],
  "alert.takeover.title": [
    "{hazard} — venga, muévete, no me discutas",
    "{hazard} — ¡arriba! Ve, que es en serio",
    "{hazard} — calla y muévete, cariño",
  ],
  "alert.takeover.details": "Enséñamelo todo",
  "alert.takeover.dismiss": "Sí, sí, vale",
  "now.status.allClear": [
    "Todo tranquilo, mi vida.",
    "Tranquilo ahora, cariño.",
    "Todo bien — siéntate, descansa.",
    "Todo bien. ¿Has comido ya?",
    "Tranquilo, gracias a Dios.",
    "Calladito. Descansa un poco.",
    "En paz ahora. Y abrígate.",
  ],
  "now.status.stayAware": [
    "Atento, ¿eh, cariño?",
    "Ojo avizor, mi vida.",
    "Estate atento, por mí.",
    "Cuidado, ¿me oyes?",
    "No te alejes, anda.",
  ],
  "now.status.sub.allClear": [
    "Nada cerca ahora. Bebe agua.",
    "Todo tranquilo. ¿Has comido algo?",
    "Nada en tu radio. Siéntate un poco.",
    "Despejado, cariño. Respira.",
    "Nada cerca. Ponte una rebeca igual.",
  ],
  "now.activity.empty": [
    "Todo quieto. ¿Has comido?",
    "No pasa nada. Descansa un poco.",
    "Todo tranquilo. Llama a tu madre, ¿eh?",
    "Nada por aquí. Tómate un caldo.",
    "Tranquilo y en calma. Aprovecha, cariño.",
  ],
  "onboarding.promise.tagline": "Vecinos cuidando a vecinos, como una familia.",
  "onboarding.promise.continue": "Venga, entra, entra",
  "onboarding.home.browse": "Solo mirando, de momento",
  "you.voice.intro": "Dime cómo te gusta que te hablen, cariño.",
};
